import { IApiError } from '@/models/apiError.model';
import { IConversationDetails } from '@/models/conversation.model';
import { ITheme } from '@/models/theme.model';

export const SLICE_NAME = 'conversationDetails';

export interface ConversationDetailsState {
  item: IConversationDetails | null;
  channelTheme: ITheme | null;
  isChannelThemeLoading: boolean;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: ConversationDetailsState = {
  item: null,
  channelTheme: null,
  isChannelThemeLoading: false,
  isLoading: false,
  error: null,
};
